import { isSafari } from 'react-device-detect';
import Loader from 'react-loader-spinner';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';

const Spinner = ({ size, type, ...rest }) => <Loader type={type ? type : isSafari ? 'Watch' : 'Puff'} color="#4a4a4a" visible={true} secondaryColor="lightgray" radius={size} height={size} width={`${size}px`} {...rest} />;

export default Spinner;
